module.exports = __webpack_public_path__ + "img/non-binary.965b01e3.svg";